<template>
  <small :class="wrapperClass" class="text-[#e24c4c] text-[11.6667px]">
    {{ getMessage() }}
  </small>
</template>

<script setup lang="ts">
  import { useI18n } from "vue-i18n";

  const { t } = useI18n();

  const props = defineProps({
    error: Boolean,
    errorMessage: String,
    wrapperClass: String,
  });

  const getMessage = () => {
    if (!props.error) return "";

    if (props.errorMessage) return t(props.errorMessage);
    return t("validation_required");
  };
</script>
